import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { MESSAGES_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { cashRegisterColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { CashRegistersRepository } from '@Repositories/Messages';

export function FrameListCashRegister() {
    const hasPermission = useHasPermission();

    const module = useListApi(CashRegistersRepository, MESSAGES_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings
            layoutSettingsContext={EnumFrontendLayoutSetting.CashRegistersTableLayout}
            name={'CashRegisterList'}
            columns={cashRegisterColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.MessagesCashRegistersCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
